import { render, staticRenderFns } from "./DeveloperEdit.vue?vue&type=template&id=fb70a74a"
import script from "./DeveloperEdit.vue?vue&type=script&lang=js"
export * from "./DeveloperEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports